import { Card } from '@heroui/react';
import styled from 'styled-components';

/* Karty na białym tle — konwencja hs-admina (patrz `TopStatsCard`), inaczej odcinają się
   od reszty panelu. */

export const WhiteCard = styled(Card)`
  background-color: #fff;
  padding: 16px 18px;
  box-shadow: none;
  border: 1px solid #e5e7eb;
`;

export const TilesRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

export const TileLabel = styled.p`
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
  margin: 0;
`;

export const TileValue = styled.p`
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin: 8px 0 0;
  line-height: 1.2;
`;

export const TileMeta = styled.p`
  font-size: 12px;
  color: #6b7280;
  margin: 4px 0 0;
`;

export const TileHint = styled.p`
  font-size: 11px;
  color: #9ca3af;
  margin: 10px 0 0;
  line-height: 1.4;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin: 16px 0 20px;
`;

/* Tabela w białej karcie, z poziomym przewijaniem zamiast rozjeżdżania układu. */
export const TableCard = styled(Card)`
  background-color: #fff;
  box-shadow: none;
  border: 1px solid #e5e7eb;
  overflow-x: auto;

  /* HeroUI zaokrągla skrajne komórki nagłówka klasami first:rounded-l-lg oraz
     last:rounded-r-lg, które kompilują się do selektorów z PSEUDOKLASĄ. Samo
     "thead th" ma niższą swoistość i przegrywa — dlatego powtarzamy tu tę samą
     pseudoklasę. */
  /* Odstęp między nagłówkiem a pierwszym wierszem bierze się z rozsunięcia komórek
     tabeli (border-spacing), a nie z marginesu na samym th. */
  table {
    border-spacing: 0;
  }

  thead th,
  thead th:first-child,
  thead th:last-child {
    border-radius: 0;
    /* HeroUI ustawia sztywną wysokość klasą h-10; zdejmujemy ją, żeby o wysokości
       decydował padding. */
    height: auto;
    padding-top: 14px;
    padding-bottom: 14px;
    font-size: 12px;
    letter-spacing: 0.02em;
  }
`;

export const Muted = styled.span`
  color: #9ca3af;
`;

export const SubText = styled.span`
  display: block;
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
`;

export const WarnText = styled.span`
  display: block;
  font-size: 11px;
  color: #b45309;
  margin-top: 2px;
`;

export const HotelLink = styled.button`
  color: #2563eb;
  text-align: left;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
`;
